import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

export class CustomLogger {
  handleError(err: HttpErrorResponse) {
    console.log(err);
    if (err.status === 403) {
      alert('Not allowed operation');
    }
    return Observable.throw(err.error);
  }
  log(message: any, prefix: string = ''): void {
    if (!environment.production) {
      if (message) {
        console.log(message.body || message);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/custom-logger.ts